import { useEffect, useState } from "react";
import { WorldRenderer } from "../../WorldRenderer"
import { WREvents } from "../../WREvents";
import { BaseVisual } from "../../../visuals/BaseVisual";
import { RobotVisual } from "../../../visuals/RobotVisual";
import { RobotAgent } from "../robot/RobotAgent";
import { RCPanel } from "../../rc/RCPanel";
import { BaseAgent } from "../agents/BaseAgent";
import { HumanVisual } from "../../../visuals/HumanVisual";
import { HumanAgent } from "../agents/HumanAgent";
import { ArmAgent } from "../robot/ArmAgent";
import { ArmVisual } from "../../../visuals/ArmVisual";
import { DragonflyVisual } from "../../../visuals/DragonflyVisual";
import { DragonflyAgent } from "../agents/DragonflyAgent";
import { ModelBasedVisual } from "../../../visuals/ModelBasedVisual";
import { AgentType } from "../../../models/Model";
import { VehicleAgent } from "../agents/VehicleAgent";
import { C4Visual } from "../../../visuals/C4Visual";
import { C4Agent } from "../agents/C4Agent";
const interval = 100;
const agents: BaseAgent[] = [];

export function AgentControl({ wr, size, position }: {
  wr: WorldRenderer,
  size: { width: number, height: number },
  position: { x: number, y: number }
}) {
  const [rcRobot, setRcRobot] = useState<RobotAgent | null>(null);
  const [isEditing, setIsEditing] = useState(true);

  useEffect(() => {
    const visualLoadedListener = async (visual: BaseVisual) => {
      if (visual instanceof ArmVisual) {
        const agent = new ArmAgent(visual);
        // await agent.setup();
        agents.push(agent);
        wr.emitEvent(WREvents.AgentsUpdated, agents);
      } else if (visual instanceof RobotVisual) {
        if (visual.robotId) {
          const agent = new RobotAgent(visual);
          // await agent.setup();
          setRcRobot(agent);
          agents.push(agent);
          wr.emitEvent(WREvents.AgentsUpdated, agents);
        }
      } else if (visual instanceof HumanVisual) {
        const agent = new HumanAgent(visual);
        // await agent.setup();
        agents.push(agent);
        wr.emitEvent(WREvents.AgentsUpdated, agents);
      } else if (visual instanceof C4Visual) {
        const agent = new C4Agent(visual);
        agents.push(agent);
        wr.emitEvent(WREvents.AgentsUpdated, agents);
      } else if (visual instanceof DragonflyVisual) {
        const agent = new DragonflyAgent(visual);
        // await agent.setup();
        agents.push(agent);
        wr.emitEvent(WREvents.AgentsUpdated, agents);
      } else if (visual instanceof ModelBasedVisual) {
        const model = visual.modelLoader.model;
        if (model.agentType === AgentType.Vehicle) {
          const agent = new VehicleAgent(visual);
          // await agent.setup();
          agents.push(agent);
          wr.emitEvent(WREvents.AgentsUpdated, agents);
        }
      }
      for (const agent of agents) {
        agent.setup();
      }
    };
    const visualRemovedListener = async (visual: BaseVisual) => {
      for (const agent of agents) {
        if (agent.visual === visual) {
          await agent.deactivate();
          if (rcRobot && agent.visual._id === rcRobot.visual._id) {
            setRcRobot(null);
          }
          agents.splice(agents.indexOf(agent), 1);
        }
      }
    };
    wr.onEvent(WREvents.VisualLoaded, visualLoadedListener);
    wr.onEvent(WREvents.VisualRemoved, visualRemovedListener);
    let timeout: any = null;
    const loop = async () => {
      for (const agent of agents) {
        await agent.loop();
      }
      // console.log({agents})
      const dirtyAgents = agents.filter(agent => agent.isDirty);

      const dirtyVisuals = dirtyAgents.map(agent => agent.visual);
      if (dirtyAgents.length > 0) {
        wr.physXService.updateObjects(dirtyVisuals);
        for (const agent of dirtyAgents) {
          agent.isDirty = false;
        }
      }
      timeout = setTimeout(loop, interval);
    };

    // console.log(Array.from(wr.dataService.visuals.values()));
    for (const visual of wr.dataService.visuals.values()) {
      visualLoadedListener(visual);
    }
    // console.log({ agents });
    loop();
    const clearAllAgents = async () => {
      setRcRobot(null);
      for (const agent of agents) {
        await agent.deactivate();
      }
      agents.length = 0; // Clear the agents array
    }
    return () => {
      clearTimeout(timeout);
      wr.off(WREvents.VisualLoaded, visualLoadedListener);
      wr.off(WREvents.VisualRemoved, visualRemovedListener);
      clearAllAgents();
    };
  }, [wr]);

  return (
    <div
      style={{
        position: "absolute",
        top: `${position.y + size.height - 112}px`,
        left: `${position.x}px`,
        width: `${size.width}px`,
        height: `112px`,
        pointerEvents: isEditing ? "all" : "none",
        // backgroundColor: isEditing ? 'rgba(100, 100, 100, 0.5)' : 'transparent',
        backgroundColor: isEditing ? 'transparent' : 'transparent',
        // backgroundColor: 'red'
      }}
    >
      <div style={{
        position: 'relative',
        top: '0px',
        width: '480px',
        left: `${size.width / 2 - 480 / 2}px`
      }}>
        {rcRobot && <RCPanel robot={rcRobot} />}
      </div>
    </div>
  )
}